export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const RESET_PERMISSIONS = 'RESET_PERMISSIONS';

